import { render, staticRenderFns } from "./KlineWaveConfigs.vue?vue&type=template&id=77b94fa6&scoped=true"
import script from "./KlineWaveConfigs.vue?vue&type=script&lang=js"
export * from "./KlineWaveConfigs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77b94fa6",
  null
  
)

export default component.exports